export default {
      id: "ic_action_three_dots-usage",
      viewBox: "0 0 17 4",
      url: "/" + "images/icons.3.109.2.svg#ic_action_three_dots-usage",
      toString: function () {
        return this.url;
      }
    }